import axios from "axios"
import moment from "moment/moment"
import React, { useEffect, useState } from "react"
import { Alert, Card, CardBody, Container } from "reactstrap"
import LabelValueRow from "./Resuable"
import AssignmentFiles from "./File"
import Spinners from "components/Common/Spinner"
const StudentAssignment = () => {
  const [data, setData] = useState([])
  const [Loading, setLoading] = useState(false)
  const token = JSON.parse(localStorage.getItem("Token"))

  const getAssignmentReport = async () => {
    try {
      setLoading(true)
      await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/assignment/get-submited-assignment",
        data: {
          acad_id: localStorage.getItem("acad_id"),
        },
        headers: {
          Authorization: token,
        },
      }).then(Res => {
        setLoading(false)
        setData(Res.data.data.reverse())
      })
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAssignmentReport()
  }, [])
  const grouped = [];

  data.forEach(item => {
    const key = `${item.date}-${item.subject}-${item.div_name}-${item.name}`;
    const existing = grouped.find(g =>
      g.date === item.date &&
      g.subject === item.subject &&
      g.div_name === item.div_name &&
      g.name === item.name
    );
  
    if (existing) {
      existing.files.push(item.file_name);
    } else {
      grouped.push({
        date: item.date,
        subject: item.subject,
        div_name: item.div_name,
        name: item.name,
        files: [item.file_name]
      });
    }
  });
  
  return (
    <div className="page-content px-0 bg-white" style={{ paddingTop: "90px" }}>
      <Container className="p-0">
        <Card className="p-1">
          <CardBody className="p-1">
            <h1 className="text-center mb-4 fs-3" style={{ color: "#3c3c3c" }}>
              Submitted Assignment
            </h1>
            {Loading ? (
              <Spinners />
            ) : data && data.length === 0 ? (
              <Alert className="text-center mt-4">
                Assignments Not Submitted
              </Alert>
            ) : (
              grouped &&
              grouped.length > 0 &&
              grouped.map((item, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "4px",
                    marginTop: "5px",
                    padding: "10px",
                    position: "relative",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="w-100">
                      <LabelValueRow label="Name:" value={item.name} />
                      <LabelValueRow
                        label="Submitted Date:"
                        value={moment(item.date).format("DD-MM-YYYY")}
                      />
                      <LabelValueRow label="Division:" value={item.div_name} />
                      <LabelValueRow label="Subject:" value={item.subject} />
                      <LabelValueRow label="Remarks:" value={item.remarks} />
                      <LabelValueRow
                        label="Out of marks:"
                        value={item.out_of_marks}
                      />
                      <LabelValueRow label="Marks:" value={item.marks} />
                      <AssignmentFiles files={item.files || []} />
                    </div>
                  </div>
                </div>
              ))
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default StudentAssignment
